module.exports = __webpack_public_path__ + "static/media/h3_what.8f448fac.webp";